import { render } from "./NcrmHomeKpiCards.vue?vue&type=template&id=0e7a96be&scoped=true"
import script from "./NcrmHomeKpiCards.vue?vue&type=script&lang=js"
export * from "./NcrmHomeKpiCards.vue?vue&type=script&lang=js"

import "./NcrmHomeKpiCards.vue?vue&type=style&index=0&id=0e7a96be&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0e7a96be"]])

export default __exports__